import { RotationBerthCall } from 'src/types/ViewModel/Stowage/Rotation/RotationBerthCall';
import { RotationPortCall } from 'src/types/ViewModel/Stowage/Rotation/RotationPortCall';
import { moveCargoOperation } from '../stowageRotationMoveUtils';
import { getBerthCalls, isValidPortCall } from '../stowageRotationUtils';
import { StowagePlan } from 'src/types/ViewModel/Stowage/StowagePlan';

export const isValidCargoDropTarget = (target: RotationPortCall | RotationBerthCall, rotation: RotationPortCall[]): boolean => {
    if ('portCallGuid' in target && 'imosPortFunction' in target) {
        // It's a RotationPortCall
        return isValidPortCall(target as RotationPortCall);
    } else {
        // It's a RotationBerthCall, check its parent port call
        const berthCall = target as RotationBerthCall;
        const portCall = berthCall.portCall || rotation.find((pc) => pc.portCallGuid === berthCall.portCallGuid);
        return portCall ? isValidPortCall(portCall) : false;
    }
};

export const onPortCallDrop = (e: React.DragEvent, portCallItem: RotationPortCall, filteredStowageRotationTree: RotationPortCall[], stowagePlan) => {
    // Check if the target port call is valid for drop operations
    if (!isValidCargoDropTarget(portCallItem, filteredStowageRotationTree)) {
        e.preventDefault();
        return [];
    }

    const berthCalls = getBerthCalls(portCallItem);
    // TODO: NULL-SAFETY - Should check if berthCalls is null/undefined before checking length
    if (!berthCalls || berthCalls.length === 0) return;

    const cargoOperationGuid = e.dataTransfer.getData('cargoOperationGuid');
    // TODO: NULL-SAFETY - Should validate cargoOperationGuid is not empty or null before using
    const sourceCargoOperation = stowagePlan.cargoOperations.find((op) => op.cargoOperationGuid === cargoOperationGuid);

    if (sourceCargoOperation && berthCalls.length > 0) {
        return moveCargoOperation(stowagePlan, sourceCargoOperation, berthCalls[0]);
    }

    return [];
};

export const onBerthCallDrop = (e: React.DragEvent, berthCallItem: RotationBerthCall, stowagePlan: StowagePlan) => {
    // Check if the target berth call's parent port call is valid for drop operations
    if (!isValidCargoDropTarget(berthCallItem, stowagePlan.rotation)) {
        e.preventDefault();
        return [];
    }

    const cargoOperationGuid = e.dataTransfer.getData('cargoOperationGuid');
    const sourceCargoOperation = stowagePlan.cargoOperations.find((op) => op.cargoOperationGuid === cargoOperationGuid);

    if (sourceCargoOperation) {
        return moveCargoOperation(stowagePlan, sourceCargoOperation, berthCallItem);
    }

    return [];
};

// TODO: ERROR-HANDLING - finish implementation, this is currently not in use and doesn't affect cursor behaviour when dragging a cargo over the rotation tree
export const onPortCallDragOver = (e: React.DragEvent, portCallItem: RotationPortCall, stowagePlan: StowagePlan) => {
    e.preventDefault();

    // Set cursor based on whether the target is valid
    if (isValidCargoDropTarget(portCallItem, stowagePlan.rotation)) {
        e.dataTransfer.dropEffect = 'move';
    } else {
        e.dataTransfer.dropEffect = 'none';
        (e.currentTarget as HTMLElement).style.cursor = 'not-allowed';
    }
};

export const onBerthCallDragOver = (e: React.DragEvent, berthCallItem: RotationBerthCall, filteredStowageRotationTree: RotationPortCall[]) => {
    e.preventDefault();

    // Set cursor based on whether the target is valid
    if (isValidCargoDropTarget(berthCallItem, filteredStowageRotationTree)) {
        e.dataTransfer.dropEffect = 'move';
    } else {
        e.dataTransfer.dropEffect = 'none';
        (e.currentTarget as HTMLElement).style.cursor = 'not-allowed';
    }
};

export const onDragLeave = (e: React.DragEvent) => {
    // Reset cursor when drag leaves the element
    (e.currentTarget as HTMLElement).style.cursor = 'default';
};
